export const getIsPosting = state => state.getIn(['creatConsultations', 'isPosting']);
export const getErrMsg = state => state.getIn(['creatConsultations', 'errMsg']);

export const getCaseRelateList = state => state.getIn(['creatConsultations', 'caseRelateList']);
export const getIsFetching = state => state.getIn(['creatConsultations', 'isFetching']);